export default function initPopup() {
  const popup = Array.from(document.getElementsByClassName("popup"))
  const popupToggles = Array.from(document.getElementsByClassName("popup-toggle"))
  const closeButtons = Array.from(document.querySelectorAll(".close-popup"))

  if (popup.length > 0) {
    const closeButton = document.querySelectorAll(".close-popup")
    let cookie
    let cookieId
    function showOnLoad(item) {
      cookieId = item.dataset.cookie_id
      cookie = Window.Cookies.get(cookieId + "-popup-hide-cookie")
      if (!cookie && !item.classList.contains("hidden")) {
        item.style.display = "block"
      }
      Window.Cookies.set(item.dataset.cookie_id + "-popup-hide-cookie", true, { expires: 7 })
    }

    function closePopup(item) {
      item.style.display = "none"
    }

    function openPopup(popupId) {

      const popup = document.getElementById(popupId)
      if (popup) popup.style.display = "block"
      if (popup) popup.classList.add("popup-show")
    }

    popupToggles.forEach((btn) => {
      const popupId = btn.nextElementSibling.id
      btn.addEventListener("click", () => openPopup(popupId))
    })

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const popup = btn.closest('.popup')
        if (popup) closePopup(popup)
        if (popup) popup.classList.remove("popup-show")
      })
    })

    if (popup.length > 0 && closeButton) {
      window.addEventListener(
        "load",
        (event) => {
          popup.forEach((item) => showOnLoad(item))
        },

      )
    }
  }
}